import {
  TextField as AriaTextField,
  type TextFieldProps as AriaTextFieldProps,
  Input,
  TextArea,
} from "react-aria-components";
import { cx } from "@/lib/cx";
import {
  type BaseFieldProps,
  controlHeight,
  FieldDescription,
  FieldErrorText,
  FieldLabel,
  fieldRoot,
  inputBase,
} from "./field";

export interface TextFieldProps extends Omit<AriaTextFieldProps, "children" | "className">, BaseFieldProps {
  className?: string;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
}

export function TextField({
  label,
  labelHidden,
  description,
  error,
  placeholder,
  multiline,
  rows = 3,
  className,
  ...props
}: TextFieldProps) {
  return (
    <AriaTextField className={cx(fieldRoot, className)} isInvalid={error ? true : props.isInvalid} {...props}>
      <FieldLabel hidden={labelHidden}>{label}</FieldLabel>
      {multiline ? (
        <TextArea rows={rows} placeholder={placeholder} className={cx(inputBase, "resize-y py-1.5")} />
      ) : (
        <Input placeholder={placeholder} className={cx(inputBase, controlHeight)} />
      )}
      {description ? <FieldDescription>{description}</FieldDescription> : null}
      <FieldErrorText>{error}</FieldErrorText>
    </AriaTextField>
  );
}
